import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Notebook, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { businessLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await businessLogin(email, password);
      navigate("/staff-login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Email ou senha inválidos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bg-cream)" }}>
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-2xl bg-[color:var(--terracotta)] text-white flex items-center justify-center">
              <Notebook className="w-6 h-6" strokeWidth={2.4} />
            </div>
            <div>
              <h1 className="font-display text-2xl font-extrabold tracking-tight text-stone-900">Carnê Fácil</h1>
              <p className="text-xs text-stone-500 font-medium">Entrar no negócio</p>
            </div>
          </div>

          <div className="carne-card p-6 animate-slide-up">
            <h2 className="font-display text-xl font-bold text-stone-900 mb-1">Etapa 1 de 2</h2>
            <p className="text-sm text-stone-500 mb-5">Entre com o e-mail e a senha do dono do negócio.</p>

            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="text-xs font-bold uppercase tracking-wider text-stone-500">Email</label>
                <input
                  data-testid="input-email"
                  type="email"
                  className="mt-1 w-full h-12 px-3 rounded-xl border border-stone-200 bg-white outline-none focus:border-[color:var(--terracotta)]"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
              <div>
                <label className="text-xs font-bold uppercase tracking-wider text-stone-500">Senha</label>
                <input
                  data-testid="input-password"
                  type="password"
                  className="mt-1 w-full h-12 px-3 rounded-xl border border-stone-200 bg-white outline-none focus:border-[color:var(--terracotta)]"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  minLength={4}
                />
              </div>
              <button
                data-testid="btn-submit-auth"
                type="submit"
                disabled={loading}
                className="btn-primary w-full mt-2"
              >
                {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                Continuar
              </button>
            </form>

            <p className="text-center text-xs text-stone-500 mt-5">
              Primeiro acesso? <Link to="/register" data-testid="link-register" className="font-bold text-[color:var(--terracotta)]">Criar meu negócio</Link>
            </p>
          </div>

          <p className="text-center text-xs text-stone-400 mt-6">
            Feito para o brasileiro que trabalha na rua. ☀️
          </p>
        </div>
      </div>
    </div>
  );
}
